import { Box, Checkbox, CircularProgress, Typography } from "@mui/material";
import React, { useContext, useEffect, useState } from "react";

import dayjs from "dayjs";
import utc from "dayjs/plugin/utc"; // ES 2015
import timezone from "dayjs/plugin/timezone"; // ES 2015
import isoWeek from "dayjs/plugin/isoWeek"; // ES 2015
import { AuthContext } from "../../../../context/AuthContext";
import { CheckCircle } from "@mui/icons-material";
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(isoWeek);
const DEFAULT_TIMEZONE = "America/Phoenix";
dayjs.tz.setDefault(DEFAULT_TIMEZONE);

const SelectEventPhases = ({ jobId, scheduledSubPhases = [], onUpdate }) => {
  const { authToken, ezorder } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const [phases, setPhases] = useState([]);

  const getJobPhases = async (jobId) => {
    try {
      setLoading(true);
      const res = await ezorder.get(`/shop/jobs/${jobId}/phases`, {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      });
      console.log(res);
      let jobInfo = res.data.job;

      setPhases(jobInfo.phases);
    } catch (error) {
      console.log(error);
      // setError(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (jobId) {
      getJobPhases(jobId);
    } else {
      setPhases([]);
    }
  }, [jobId]);

  return (
    <Box>
      {/* Phases */}
      {loading ? (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            minHeight: "200px",
          }}
        >
          <CircularProgress size="3rem" />
        </Box>
      ) : (
        <Box>
          {phases &&
            phases.map((phase) => (
              <Box key={phase.id} sx={{ marginTop: "12px" }}>
                <Typography>{phase.name}</Typography>
                <Box sx={{ paddingLeft: "16px" }}>
                  {phase.subPhases &&
                    phase.subPhases.map((subPhase) => {
                      let lastScheduled = "TBD";
                      if (
                        subPhase.calendarEvents &&
                        subPhase.calendarEvents.length > 0
                      ) {
                        let latest = null;
                        for (let event of subPhase.calendarEvents) {
                          latest =
                            latest > new Date(event.endDate)
                              ? latest
                              : new Date(event.endDate);
                        }

                        lastScheduled = `${
                          subPhase.calendarEvents[0].assignedTo
                            ? subPhase.calendarEvents[0].assignedTo
                                .map((u) => u.fullName)
                                .join(", ")
                            : ""
                        } on  ${dayjs(latest)
                          .tz(DEFAULT_TIMEZONE)
                          .format("MM/DD/YY")}`;
                      }

                      return (
                        <Box key={subPhase.id}>
                          <Box>
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                magin: 0,
                                padding: 0,
                              }}
                            >
                              {subPhase.progress >= 100 ? (
                                <CheckCircle color="success" />
                              ) : (
                                <Checkbox
                                  disabled={subPhase.progress >= 100}
                                  style={{
                                    magin: 0,
                                    padding: 0,
                                  }}
                                  checked={
                                    // TODO: IF this subPhase is in the calendarEvent.subPhases, then true. Else false
                                    scheduledSubPhases &&
                                    scheduledSubPhases.some(
                                      (scheduledSubPhase) =>
                                        scheduledSubPhase.id == subPhase.id
                                    )
                                  }
                                  onChange={(e) => {
                                    // TODO: add to calendarEvent.subPhases
                                    if (e.target.checked) {
                                      onUpdate([
                                        ...scheduledSubPhases,
                                        subPhase,
                                      ]);
                                    } else {
                                      let scheduledSubPhasesCopy = [
                                        ...scheduledSubPhases,
                                      ];
                                      let idxToRemove =
                                        scheduledSubPhasesCopy.findIndex(
                                          (scheduledSubPhase) =>
                                            scheduledSubPhase.id == subPhase.id
                                        );
                                      scheduledSubPhasesCopy.splice(
                                        idxToRemove,
                                        1
                                      );
                                      onUpdate(scheduledSubPhasesCopy);
                                    }
                                  }}
                                />
                              )}

                              <Typography>
                                {subPhase.name} (last assigned - {lastScheduled}
                                )
                              </Typography>
                            </div>
                          </Box>
                        </Box>
                      );
                    })}
                </Box>
              </Box>
            ))}
        </Box>
      )}
    </Box>
  );
};

export default SelectEventPhases;
